/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { IInputBaseProps, InputBase } from "../InputBase";

import "./Input.scss";

export interface IInputProps extends IInputBaseProps {
	className?: string;
}

const Input = React.forwardRef<HTMLDivElement, IInputProps>(({ className, ...props }, ref) => {
	const baseClass = BEM("edt-input");

	if (className) {
		baseClass.add(className);
	}

	return <InputBase {...props} baseClassName="edt-input" className={baseClass.toClassName()} ref={ref} />;
});

const InputMemo = React.memo(Input);

export { InputMemo as Input };
